import { postFetch } from '../fetch';

import { apiConfig } from '../config';

export function postClassCreateStudent(
    classId: any,
    fullName: any,
    loginId: any,
    { getParentIsBinded, getPinAndPass, getExpandBinded }: any
) {
    const { apiPostClassCreateStudent } = apiConfig.getStaticUrls();

    return postFetch(
        `${apiPostClassCreateStudent}${classId}/`,
        {
            fullName,
            loginId,
            withCredentials: getPinAndPass,
            withBinded: getParentIsBinded,
            expandBinded: getExpandBinded,
        }
    );
}
